// API
import type { AxiosError, InternalAxiosRequestConfig } from 'axios';

// HELPERS
import { session } from '@/helpers/auth';
import { isNullString } from '@/helpers/string';

// LOGGING
import { logger } from '@/shared/common/utils/logger.util';

export const requestInterceptor = async (
  config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> => {
  const token = session();
  const auxConfig = { ...config };

  if (!isNullString(token)) {
    auxConfig.headers = auxConfig.headers || {};
    auxConfig.headers.Authorization = token;
  }

  return auxConfig;
};
export function requestErrorInterceptor(
  error: AxiosError
): Promise<AxiosError> {
  if (!error.response) {
    logger.error(
      'NETWORK ERROR',
      { url: error.config?.url, method: error.config?.method },
      error
    );
    return Promise.reject(error);
  }

  return Promise.reject(error);
};
